<template>        
  <div>
    <button @click="openDialog"></button>
    <formPasswordValidation :dialog="visible" />
  </div> 
</template>
  
  <script>
  import formPasswordValidation from './components/form_change_pass_security_components.vue';
  
  export default {
    name: 'PasswordValidation',
    components: {
      formPasswordValidation,
    },
    data() {
    return {
      visible: false,
    };
  },
  methods: {
    openDialog() {
      this.visible = true;
    },
  },
  }
  </script>
  
  <style lang="css" scoped>
  
  </style>